import { Modal } from '@indipia/ui-core';
import { StepMap } from './StepMap';

export interface SiteMapPickerPopupProps {
  /** 안내 문구용 도로명 주소 */
  roadAddress: string;
  /** 초기 센터 좌표 (기존 저장 좌표 또는 지오코딩 결과). 미확보 시 폴백 센터 */
  initialLat?: number;
  initialLng?: number;
  onClose: () => void;
  /** 핀 확정 시 확정 좌표 전달 */
  onConfirm: (coord: { lat: number; lng: number }) => void;
  /** 저장 진행 중 */
  submitting?: boolean;
  /** 헤더 제목 (기본 '현장 위치 지정') */
  title?: string;
}

/**
 * 현장 위치 지도 선택 팝업 (단독) — 현장 수정 등에서 좌표만 지정할 때 사용.
 * 등록 플로우와 동일한 StepMap을 모달 껍데기에 얹어 재사용한다.
 */
export function SiteMapPickerPopup({
  roadAddress,
  initialLat,
  initialLng,
  onClose,
  onConfirm,
  submitting = false,
  title = '현장 위치 지정',
}: SiteMapPickerPopupProps) {
  // 딤·포커스 트랩·Esc·scrim 클릭·포커스 복원은 공용 Modal 이 갖는다 (D-09 §15.6)
  return (
    <Modal open onClose={onClose} title={title} size="lg">
      {/* .modal-body 는 스크롤 컨테이너가 아니므로 본문 높이를 여기서 제한한다 */}
      <div className="max-h-[60vh] overflow-y-auto">
        <StepMap
          roadAddress={roadAddress}
          initialLat={initialLat}
          initialLng={initialLng}
          onConfirm={onConfirm}
          confirmLabel="이 위치로 저장"
          submitting={submitting}
        />
      </div>
    </Modal>
  );
}
